import { render, staticRenderFns } from "./portalContribuyentePage.vue?vue&type=template&id=40a38d47&"
import script from "./portalContribuyentePage.vue?vue&type=script&lang=js&"
export * from "./portalContribuyentePage.vue?vue&type=script&lang=js&"
import style0 from "./portalContribuyentePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports